import { Component } from '@angular/core';
import { MssFieldBaseFieldTypeComponent } from '../mss-field-base.component';
import { MSS_FORMLY_IMPORTS } from '../../formly-standalone-imports';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'lib-ff-currency',
  templateUrl: './currency.component.html',
  imports: [MSS_FORMLY_IMPORTS, FormsModule, ReactiveFormsModule],
})
export class CurrencyFieldTypeComponent extends MssFieldBaseFieldTypeComponent {
  errorId?: string;
  errorDescriptionId?: string;
}
